import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionTypes } from "../constants/action-types";
import { apiCall } from "../../api/api";
import axios from "axios";

export const createMoveService = createAsyncThunk(
  ActionTypes.CREATE_MOVE_SERVICE,
  async (moveServiceData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("move-service/create", "post", moveServiceData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateMoveService = createAsyncThunk(
  ActionTypes.UPDATE_MOVE_SERVICE,
  async (moveServiceData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "move-service/update",
        "patch",
        moveServiceData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchInventoryFromImage = createAsyncThunk(
  ActionTypes.GET_INVENTORY_FROM_IMAGE,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "inventory/upload-inventory",
        "post",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getInventoryData = createAsyncThunk(
  ActionTypes.GET_INVENTORY_DATA,
  async (moveServiceId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(`inventory/${moveServiceId}`, "get");
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const addInventoryItems = createAsyncThunk(
  ActionTypes.ADD_INVENTORY_ITEMS,
  async (inventoryData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(`inventory/manual-item`, "post", inventoryData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getMoveService = createAsyncThunk(
  ActionTypes.GET_MOVE_SERVICE,
  async (canonicalId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `move-service/${canonicalId}`,
        "get",
        canonicalId
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createUser = createAsyncThunk(
  ActionTypes.CREATE_USER,
  async (moveServiceData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("user/create", "post", moveServiceData);
      return res;
    } catch (error: any) {
      if (error.response && error.response?.data?.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createCustomerStripeSession = createAsyncThunk(
  ActionTypes.CREATE_CUSTOMER_STRIPE_SESSION,
  async (checkoutSessionDto: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "move-service/checkoutSession",
        "post",
        checkoutSessionDto
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const updateInventoryItem = createAsyncThunk(
  ActionTypes.UPDATE_INVENTORY_ITEM,
  async (updateData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/update-item", "put", updateData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const deleteInventoryItem = createAsyncThunk(
  ActionTypes.DELETE_INVENTORY_ITEM,
  async (deleteData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("inventory/delete-item", "delete", deleteData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createStorage = createAsyncThunk(
  ActionTypes.CREATE_STORAGE,
  async (storageData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall("storage/create", "post", storageData);
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const createOrUpdateDeliveryDetails = createAsyncThunk(
  ActionTypes.CREATE_OR_UPDATE_DELIVERY_DETAILS,
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        "delivery-details/create-or-update",
        "post",
        data
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const saveVolumne = createAsyncThunk(
  ActionTypes.SAVE_VOLUME,
  async (canonicalId: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `inventory/saveVolume/${canonicalId}`,
        "post",
        undefined
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getUserByPhoneNumber = createAsyncThunk(
  ActionTypes.GET_USER_BY_PHONE_NUMBER,
  async (phoneNumber: string, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `user/users/${phoneNumber}`,
        "get",
        phoneNumber
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const attachUserWithMove = createAsyncThunk(
  ActionTypes.ATTACH_USER_WITH_MOVE,
  async (params: any, { rejectWithValue }) => {
    const { canonicalId, userId } = params;
    try {
      const res = await apiCall(
        `/move-service/update-move-with-user/${canonicalId}`,
        "patch",
        { userId }
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getMovesByPhoneNumber = createAsyncThunk(
  ActionTypes.GET_MOVE_SERVICE_BY_PHONE_NUMBER,
  async (phoneNumber: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(`move-service/move/${phoneNumber}`, "get");
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const deleteMoveService = createAsyncThunk(
  ActionTypes.DELETE_MOVE_SERVICE,
  async ({ id }: { id: any }, { rejectWithValue }) => {
    try {
      const res = await apiCall(`move-service/delete/${id}`, "delete");
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const sendCancellationNotification = createAsyncThunk(
  ActionTypes.SEND_CANCELLATION_NOTIFICATION,
  async (cancelNotificationData: any, { rejectWithValue }) => {
    try {
      const res = await apiCall(
        `move-service/cancel-notification`,
        "post",
        cancelNotificationData
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const checkUserExist = createAsyncThunk(
  ActionTypes.CHECK_USER_EXIST,
  async (
    {
      email,
      carrierCanonicalId,
    }: { email: string; carrierCanonicalId: string },
    { rejectWithValue }
  ) => {
    try {
      const res = await apiCall(
        `/user/user/check-exist?email=${email}&carrierCanonicalId=${carrierCanonicalId}`,
        "get"
      );
      return res;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
